import { render, staticRenderFns } from "./moreSelect.vue?vue&type=template&id=d1037bea&scoped=true&"
import script from "./moreSelect.vue?vue&type=script&lang=js&"
export * from "./moreSelect.vue?vue&type=script&lang=js&"
import style0 from "./moreSelect.vue?vue&type=style&index=0&id=d1037bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1037bea",
  null
  
)

export default component.exports